import { FaFileExcel, FaMoneyCheck } from "react-icons/fa";
import { Container, Opcao, TextoOpcao } from "./style";

interface Props {
  aberto: boolean;
  onClickComprovantes: () => void;
  onClickDetalhado: () => void;
}

export function OpcoesExportar({
  aberto,
  onClickComprovantes,
  onClickDetalhado,
}: Props) {
  return (
    <Container aberto={aberto}>
      <div>
        <Opcao>
          <TextoOpcao onClick={onClickComprovantes}>
            <FaMoneyCheck style={{ marginRight: "10px" }} />
            Baixar comprovantes
          </TextoOpcao>
        </Opcao>
        <Opcao>
          <TextoOpcao onClick={onClickDetalhado}>
            <FaFileExcel style={{ marginRight: "10px" }} />
            Relatório detalhado
          </TextoOpcao>
        </Opcao>
      </div>
    </Container>
  );
}
